
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBkuYWP22Si8bV8wrVkF1a3929bry0kIsA",
  authDomain: "southern-rehab-care.firebaseapp.com",
  projectId: "southern-rehab-care",
  storageBucket: "southern-rehab-care.firebasestorage.app",
  messagingSenderId: "1409583291",
  appId: "1:1409583291:web:f163d36d943bb97483c19e"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection };  // Correct export

